module.exports = __webpack_public_path__ + "img/network-configuration.93544ae9.jpg";